/*
      ___          ___          ___          ___
     /  /\        /  /\        /  /\        /  /\     ___
    /  /::\      /  /::\      /  /::|      /  /::\   /__/\
   /  /:/\:\    /  /:/\:\    /  /:|:|     /  /:/\:\  \  \:\
  /  /::\ \:\  /  /:/  \:\  /  /:/|:|__  /  /::\ \:\  \__\:\
 /__/:/\:\_\:\/__/:/ \__\:|/__/:/ |:| /\/__/:/\:\ \:\ /  /::\
 \__\/  \:\/:/\  \:\ /  /:/\__\/  |:|/:/\  \:\ \:\_\//  /:/\:\
      \__\::/  \  \:\  /:/     |  |:/:/  \  \:\ \:\ /  /:/__\/
      /  /:/    \  \:\/:/      |__|::/    \  \:\_\//__/:/
     /__/:/      \__\::/       /__/:/      \  \:\  \__\/
     \__\/           ~~        \__\/        \__\/
*
* Rudy Affandi (2015)
* Adnet Communications Inc.
* app.js
*/

$(document).ready(function(){

    // List.js
    var options = {
        valueNames: [ 'name' ]
    };

    //var clientList = new List('clients', options);

    // Sidebar toggler

    $('.sidebar-toggle').on('click', function(){
        $(this).find('i').toggleClass('uk-icon-angle-double-left uk-icon-angle-double-right');
        $('body, .sidebar').toggleClass('uk-collapsed');
        resizeGrid;
        $(window).resize();
    });

    // Button confirmation dialog
    $('.confirm').click(function(e){
        e.preventDefault();
        $url = $(this).attr('href');
        $caption = $(this).text();
        UIkit.modal.confirm("<h3>" + $caption + "</h3><img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABsZJREFUaIHFWl1MnFUafs77TQdakE5t6nalSdVhOrSBQXFrrK4X1SwUYqs0ppUaQTGx/sSsNRqXGy9WL0xq1vXCbe3dkizoWGpjy0xLFZJC1aLQMiAUZ1wXDLRKEWT4KTPzvWcvYKYjMJ1vzkfrc/W95zzvz8n3c55zziewBFh/vHutVcNWZnkvEecyKIeAVczIBAAiTDAwSuAAM10gEl+FdDT3P5x3yWxuoeqYe6pntR6O7JFCVAjgTyoxJPCNkLJGRKx13+3IvawSI+UBOI6dy4amvQYhngWwXCXpIpiGlIeg6/v92+8aTMXR8AA2ubutoUx9nxD0BoAVKZdoDFNS8t+tE9q7PbvyQkYcDA0gt+H8hjCEm4gKzNVnDMzcaSHs7isp6EvGpWQEh8dXFoZov1HFAwARFUSY2h3erp1JudfqdHh9eyFlPRFlqhRy26UB3HZpQMUVRMgA8+Ecr++5a/ISdTi8vr2AOAgipS+VkBLPHK9FVUMthJQqIQAiISAO5Hi6nk9IWazR4fGVAfJfallncV/318jt92Pj//zY8u3XZkJBSH4/0eO0YAC5Dec3sJQ1ACV9PxIhLTSDJ0+4Y3aF14200IxqOIBIMPO/nd5O54KueGOTu9s697VReuajKGvxYvX4aMxePT6KR1u9ZkKCiDJ1kHuTu9v6m/Z4I5Sp7zP7tbll9DJ2tJ5Y0P5IywncMqo02cYgAFcoU98X3xYbgOPYuey5ScoUKr0fYVkkvKB9WSSMSu9HZsNDCHrDcexcdtS+egcs2qswOcPmf9+De3o7AADpOXasf+tNrH/rTaTb7QCAe3o7kP99j5kUALACmvZa1CBgVpgBYq+ZqJquo6qhLmavq/4bbMVFsBUXYV3167H2qoY6aLpuJhUgxLM5no41wNwA9HBkD0wKs+K2ZqwbHorZlpUrr17bbLHrdcNDKG5rNpMKAJYLYSkH5gYghagwEy1rMojdTUcN83c3HUXWZNBMSoBFJQDQ+uPda1X1fBTlnx3BiivThvkrrkyj/LMjZlIChEJnY++tZNWw1Uyc2y/246H2lpT9HmpvwR1DajopCj0S3krM8l7VALN6p05J6wgpzemkWWwhIs5V9b6/qw3OAb9ydueAH/f72pT9pRROYlCOivN8vaOKikY30mfUdBIRO4iAVSrOO097cHNwTClxPFaNj6GspUHNmclG0a2PVPCH0WFsP3NSLeki2NF6Emt/+Tl1R+KblCRzIr2jCoseQYWiTiIiTKTi4Ar0YHPvuaQ8PXg1rD6efNLafOE87vR3p1IKwBQkBkaTM2eh6TqqPLWGuIP738F46xmMt57B4P53DPk85f0wNZ1EPGYhcACgO4zwt7U1I3v4oqHYUz09+GHfK8aLAZA9fBElZz/H8fuKDPGZyU/MdMEIOWsyiF0p6B2haci8uxCZhYUQmmbYb1fTp7BNjBvLIWQfEYmvjJD3nPrEsN6htDTYDx2E/eAB2D84APuhg6C0NEO+y2em8bhxnfQlhXQk1bb2wX482HHaaFDYiv6CDJcrZme4XLBtKzbs/2BHK+yDPyTlaZZlzdT/cN4lCXyTiCSkxNOe1DSLFrcWiMKSlWXYP6qTSHJiEqOjr2jjEM051CTi/bnrLJwDAcPJAeDXpmbw1NXHjaemMfZ5U0oxNvz4XzzQeTZhvyTUAHMLGhGx1gFY8ICnz8zgyZMfp5QYAEJDQ/BXPYORw/UYOVwP/9NVCA0NJXechydOfozloSuLdU1DhmuBuN1ph8f3Twjx13jWnlP1KDvtSTnxUuLoAyX4T9Fjv22U8j1/qetlIH5XQtf3A5iKmmt/+RnbzzTemCqvge1fNOKPIz/FN03N1Qpg3vlAjqfzdSHobWB2N22NyY2opcJl22pcXnkzAEBKWR0odb0d7bPEE60T2rszGXo5ERWMZK3CSJaS0r5ukIDPOkH/iG9bsHXu9HY6I0ztRMi4caUlBzMmLcR3zz+1WSCn+0oK+ohQAWZTi9UlBbMUQjy12JHTousBf0n+ESnoxetfmTEI0l4KlOYdXqwv4YImUJp/QEq88LveCWYpJV78riTv/USUpMdHDm/XTmbU3Oh3ghmTQkNlYFt+/bV4hs6/nN5Opw5yC8CVnG0eEvBp4F1LcswKzL7Y1qDYLKWsRtxkdx0wJaWstgbFZiPFA2Z+NZByL4jSU69xETBfgRAfXNdfDeYjx9OxRghLOVhUglCoFITRIQk1kOHaQGnhsEoI5QHEw9nYe6seCW8FsEVK4SRiB5hsIL5ptlAKgniMmfxCyD4AX2qWZc19RRtTl6jz8H9BQI2XAH+K5QAAAABJRU5ErkJggg==' alt='Are you absolutely sure?' /> Are you sure?", function(){
            window.location.href = $url;
        });
    });

    // Button confirmation dialog
    $('.notyet').click(function(e){
        e.preventDefault();
        UIkit.modal.alert("<img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAtCAYAAADoSujCAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAA3pJREFUaIHtWUtrFFkU/s6pTptOp2W0NQ90Bl0IihgYbV0o6ICoqAnuBkRcGXXc60LRgRHH+QEuREVQEUFwpRNEEeJC3di6cOOAIo6S2CbE+OiYdKfqHBfamaSrbrpKq8iU5IO7OX3u94B7b9+qIhgg9/euUdUjgKz5XOG7BD3Kq87cM80JA/Jgz1oV+R2E1RVdBv6g3Ok7Xv3kSZLv/FXBlxiwJtQhNqm1nVeeuhK2cQCQ+3u3qzoXmZkn6sIhwg5ecfpy9RxXAH20b5aUR58zeKaniOAt15UW0s/n34ZnHZB7u2Zr0nrOQMbzd8h7TtYtoLaTg+PrXN2oI3a7yTwAMOMHlRnt3265CjOsbSbzAMDgmVqSDnfdVaEfa4qp1u4JCtH5tZv0p+qKO4DoSx9EL3yZCgAiH7qq/1aXXAGoPvE3gHcmDhEZJGu0K6jBWtCyXhXgwyQt76iufK266A7QdnJQlTrV44BSEMjizrA3MADw6rNviLDbpAtgt5eu5zEKAI/zXdqKh2hEAQBQRAteYQWW5LYY54SBf/Jd2ooHaMTrcbrLsTi31VM3YSIaQjOeYnNENs0oohlPsMV3v3sTxwxjAVSVVDVRGUQErzG+J4rhU3dsOVGhUGi2bfscgA3MPHZ1sIqvkb1xCNZQnzG909iMgU3H4aSbjD2R8LCF0qxF/eXWZeuop6fnGhG1G5v/b+bHody09BX19vaWACTjZh4A1EqC42oeAEjs/zZx3MwDgJ1u+vw/4F/0LzjpuTVED8Ia6o+eJ9OC/vXHnERczQ9sPA5JZUH2ic0aR/NOei5ExOFJzWdaaot+KPgTDYvni/kKWMny3ewpevNQYNGweJi5xKPZRYU4mgcAVe1K6Ly2X0rA7eTgsxYSG3a6Cf3rjznaMMeCqotMVR2r2IfZtw5b1scBgLzvgxUeSWUBEW/zPnkGNvwJO5V1KjzMXBaR6yLym/Fun8/n3e4B5HK5SJ8Hgup+P9fpuGI6wFRjOsBUI/YBjK9VTOju7g48J0oENlMsFkejMFJBJmN8Qe2J2C+h6QBTjdgH+JoTxQndxUR4P2EZEDhAR0dHpMeo6TptQuyX0Hcd4H11QURC/7T0rbrGACJyrrpGRK5aBDgfRNe4IRsaGg6MjIw4IrITAJj5QiqVOhiKxUlQX1+/f3h42CGinSKitXQ/ARL8e9BU/bKrAAAAAElFTkSuQmCC' alt='' /> This function is not ready for prime time yet.");
    });

    // Button confirmation dialog
    $('.warning').click(function(e){
        e.preventDefault();
        UIkit.modal.alert("<img src='data:image/png;base64,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' alt='Under Construction' /> This function is not available on this environment.");
    });

    // SVG utility
    $('.svg-img img, img.svg-img').each(function(){
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    /* Show syntax highlighter */
    //SyntaxHighlighter.all();

    /* CRUD stuff */
    $(':checkbox[name=check-all]').click (function () {
        $(':checkbox[name=check-entry]').prop('checked', this.checked);
    });

    /* Datatables */
    var dTable = $('.sortable').DataTable({
        'dom': '<lf<t>ip>',
        'iDisplayLength': 50,
        'autoWidth': false,
  		'responsive': true,
        'lengthMenu': [[10, 25, 50, -1], [10, 25, 50, 'All']],
        'fnPreDrawCallback':function(){
            $('.dtable').hide();
            $('.loading').show();
        },
        'fnDrawCallback':function(){
            $('.dtable').show();
            $('.loading').hide();
        },
        'fnInitComplete':function(){
        }        
    });

    $('.dataTables_wrapper').wrapAll('<form id="form" class="uk-form" data-parsley-validate="" />');

    /* Delete hosted zone */
    $('#delete-zone').click(function() {
        //var itemTitle = $(this).find(':selected').data('title');
        var deleteMsg = 'Are you sure you want to delete the selected hosted zone for ';
        var modalIndex = Math.ceil(Math.random()*100);
        createUiModal(modalIndex,'title',deleteMsg);
        var modal = UIkit.modal('#modal-' + modalIndex);
        modal.show();
        return false;
    });

    //select all checkboxes
    $(".select-all").change(function(){  //"select all" change 
        $(".additional-field").prop('checked', $(this).prop("checked")); //change all ".checkbox" checked status
    });

    //uncheck "select all", if one of the listed checkbox item is unchecked
    $('.additional-field').change(function(){ //".checkbox" change 
        if(false == $(this).prop("checked")){ //if this item is unchecked
            $(".select-all").prop('unchecked', $(this).prop("unchecked")); //change "select all" checked status to false
        }
    });

    /* uiKit Modal window, toggler and builder */
    function createUiModal(id,title,msg){
        var modalBox = '<div id="modal-' + id + '" class="uk-modal">';
            modalBox  += '<div class="uk-modal-dialog">';
            modalBox  += '<div class="uk-modal-header"><h2>Confirm</h2></div>';
            modalBox  += '<p>' + msg + title + '</p>';
            modalBox  += '<div class="uk-modal-footer">';
            modalBox  += '<p class="uk-text-right"><a href="#" class="uk-button uk-button-primary uk-button-large">Yes</a> ';
            modalBox  += '<a href="" class="uk-button uk-button-danger uk-button-large uk-modal-close">Cancel</a></p>';
            modalBox  += '</div>';
            modalBox  += '</div>';
            modalBox  += '</div>';
        $('body').append(modalBox);
    }

    /* ParsleyJS */
    if ($('#form').length) {
        var form = $('#form').parsley();
    }

    /* AJAX-enabled data entry form processor */
	$('.delete-symbol').click(function(e){
		e.preventDefault();
		var symbol = $(this).data('symbol');
        var triggerURL = $(this).attr('href');
        console.log('Symbol: ' + symbol + ', url: ' + triggerURL);
		UIkit.modal.confirm('Are you sure wants to delete ' + symbol + '?', function(){
            window.location.href = triggerURL;
        });
	});

    $.ajaxSetup({
        headers: { 'X-CSRF-Token' : $('meta[name=_token]').attr('content') }
    });

    $('#entryForm').on('submit', function(e){
        e.preventDefault();

        var formData        = $(this).serialize(); // form data as string
        var formAction      = $(this).attr('action'); // form handler url
        var formMethod      = $(this).attr('method'); // GET, POST
        var entryFormModal  = UIkit.modal('#entryFormModal');

        $.ajax({
            type  : formMethod,
            url   : formAction,
            data  : formData,
            cache : false,
            beforeSend : function() {
            },
            success : function(data, textStatus, xhr) {
                var msg = $.parseJSON(xhr.responseText);
                UIkit.notify({
                    message : msg.message,
                    status  : msg.type,
                    timeout : 5000,
                    pos     : 'top-center'
                });

                if (msg.type == 'success') {
                    entryFormModal.hide();
                    location.reload();
                }

            },
            error : function(data, textStatus, xhr) {
                UIkit.notify({
                    message : 'There is an error with the form data',
                    status  : 'error',
                    timeout : 5000,
                    pos     : 'top-center'
                });

            }
        });
    });



}); // End of DOM ready

function resizeGrid() {
    var gridFilter = $('ul#grid-filter').find('li');
    if (gridFilter.hasClass('uk-active')) {
        $('ul#grid-filter li.uk-active a').triggerHandler('click');
    } else {
        $('ul#grid-filter li a#ascending').triggerHandler('click');
    }
}
